// extracted by mini-css-extract-plugin
export default {"notFoundPage":"_404_notFoundPage__FInW+"};